<template>
  <div class="price-form">
    <ul v-if="!isFormFetching" class="price-list">
      <li
        v-for="(item, idx) in filteredCheckPrint"
        :key="idx"
        class="price-item"
        :class="{ discount: item.red }"
      >
        <span class="text">{{ item.name }}</span>
        <span class="value">{{
          `${item.value} ${item.value === 'Бесплатно' ? '' : '&#8381;'}`
        }}</span>
      </li>
    </ul>
    <div v-else class="spinner-container">
      <Spinner />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { GENERAL_STORE } from '@apps/order-form/src/store'
import Spinner from '@features/UI/FontAwesomeSpinner.vue'

export default {
  name: 'PriceForm',
  components: {
    Spinner,
  },
  computed: {
    ...mapState(GENERAL_STORE, ['advanceCheque', 'isFormFetching']),

    filteredCheckPrint() {
      return this.advanceCheque.filter(el => el.name !== 'Итого доставка')
    },
  },
}
</script>

<style scoped>
.discount {
  color: #fc6110 !important;
}

.app-loader {
  padding: 30% 0;
}

.price-form {
  overflow-y: auto;

  height: 30%;
  max-height: 35vh;
  padding-right: 5px;
}

.spinner-container {
  display: flex;
  align-items: center;
  justify-content: center;

  height: 140px;

  font-size: 34px;
}
</style>
